export default {
	download(src, filename) {

		let link = document.createElement('a');
		//设置下载的文件名
		link.download = filename;
		link.style.display = 'none';
		//设置下载路径
		link.href = src;
		//触发点击
		document.body.appendChild(link);
		link.click();
		//移除节点
		document.body.removeChild(link);
	},
	copy(text) {
		let input = document.createElement("textarea")
		let currentFocus = document.activeElement
		document.body.appendChild(input)
		input.readOnly = 'readonly'
		input.value = text
		input.focus()
		let flag = null
		if (input.setSelectionRange)
			input.setSelectionRange(0, input.value.length)
		else
			input.select()
		try {
			flag = document.execCommand("copy")
		} catch (eo) {
			flag = false
		}
		input.blur()
		document.body.removeChild(input)
		currentFocus.focus()
		currentFocus.blur()
		return flag
	}
}
